import * as React from 'react';

import { Profile } from 'components';
import { Redirect } from 'react-router-dom';
import { getName, useBreakpoints } from "utils";
import { observer } from 'mobx-react-lite';
import { paths } from 'routing';
import { useStores } from 'hooks';
import { useStyles } from './Header.styles';
import { Description } from "../../Main/components/Description";
import { Grid } from '@material-ui/core';

type HeaderProps = {};

const Header: React.FC<HeaderProps> = () => {
  const { dataStore, formStore } = useStores();
  const styles = useStyles({ hasParticipant: !!dataStore.selectedParticipant });
  const { isMd } = useBreakpoints()
  const profileSize = isMd ? "large" : "small";

  return (
    <>
      {!dataStore.isActive && <Redirect to={paths.main} />}
      <Grid>
        <section className={styles.root}>
          {dataStore.selectedParticipant && (
            <Profile
              size={profileSize}
              amount={formStore.amount.value}
              currency={dataStore.currency}
              img={dataStore.selectedParticipant.personage.imageLink}
              hasAmount
              hasParticipant={!!dataStore.selectedParticipant}
              name={getName(
                dataStore.selectedParticipant.personage.firstName,
                dataStore.selectedParticipant.personage.lastName
              )}
            />
          )}
          <Profile size={profileSize} name={dataStore.appData?.recipient.name} hasParticipant={!!dataStore.selectedParticipant} />
        </section>
        <Description/>
      </Grid>
    </>
  );
};

export default observer(Header);
